module.exports = __WEBPACK_EXTERNAL_MODULE_25__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom","root":"ReactDOM"}
// module id = 25
// module chunks = 0